/*
 * ifshe cart fee-line glue
 * Pairs the hidden "product-options" up-charge line (fee tier x qty, or 0.01 x cents) with its personalized product.
 * Removing the personalized item also clears its paired fee line (matched on _options_id),
 * so a shopper can never end up with a stray add-on charge or drop the charge but keep the item.
 */
(function () {
  "use strict";

  function removeGroup(oid) {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (it) {
          if (it.properties && it.properties._options_id === oid) updates[it.key] = 0;
        });
        if (!Object.keys(updates).length) { window.location.href = "/cart"; return; }
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates })
        }).then(function () { window.location.href = "/cart"; });
      })
      .catch(function () { window.location.href = "/cart"; });
  }

  // cart-01 fix: ONE delegated listener on document, instead of binding each remove link.
  // The theme's AJAX cart update replaces .cart-items innerHTML without firing cart:refresh,
  // which orphaned the old per-link binding — so after a shopper changed any line's quantity,
  // removing a personalized item left its paired $0.01 fee line stranded in the cart. Delegation
  // covers current AND future (re-rendered) remove links with no rebind needed.
  function onClick(e) {
    var link = e.target.closest && e.target.closest("[data-options-remove]");
    if (!link) return;
    var oid = link.getAttribute("data-options-id");
    if (!oid) return;              // no group id -> fall back to native single-line remove
    e.preventDefault();
    removeGroup(oid);
  }
  document.addEventListener("click", onClick);

  // Self-heal, once per cart-page load, per _options_id group:
  //  - fee line whose personalized item is gone (or with no _options_id) -> drop it
  //  - 2026-11-03: fee lines must total _options_price x qty of their item. A duplicate (lost-response
  //    retry) is trimmed to the one right line; any other mismatch (item without its fee = undercharge,
  //    or wrong amount) drops the whole group so it can't reach checkout. Amounts are only checked in
  //    the shop currency (converted prices can't match to the cent).
  function lineCents(it) { return (it.original_price != null ? it.original_price : it.price) * it.quantity; }
  function sweepOrphans() {
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    var strict = rate === 1;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var groups = {}, updates = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {}, isFee = p._options_fee === "1", oid = p._options_id;
          if (!oid) { if (isFee) updates[it.key] = 0; return; }
          var g = groups[oid] || (groups[oid] = { mains: [], fees: [] });
          (isFee ? g.fees : g.mains).push(it);
        });
        Object.keys(groups).forEach(function (oid) {
          var g = groups[oid];
          if (!g.mains.length) { g.fees.forEach(function (f) { updates[f.key] = 0; }); return; }
          if (!strict) return;
          var want = g.mains.reduce(function (a, m) {
            return a + Math.round((parseFloat((m.properties || {})._options_price) || 0) * 100) * m.quantity; }, 0);
          var got = g.fees.reduce(function (a, f) { return a + lineCents(f); }, 0);
          if (got === want && g.fees.length <= 1) return;
          // keep one fee line that can carry the right amount (exact first, else a line whose unit price
          // divides it -> fix its quantity, e.g. a tier line merged x2); drop the other fee lines
          var unit = function (f) { return f.original_price != null ? f.original_price : f.price; };
          var keep = g.fees.filter(function (f) { return lineCents(f) === want; })[0]
            || g.fees.filter(function (f) { return unit(f) > 0 && want % unit(f) === 0; })[0];
          if (keep && want > 0) {
            g.fees.forEach(function (f) { if (f !== keep) updates[f.key] = 0; });
            if (lineCents(keep) !== want) updates[keep.key] = want / unit(keep);
          }
          else { g.mains.concat(g.fees).forEach(function (it) { updates[it.key] = 0; }); }
          if (window.console) console.warn("[ifshe-po] cart fee mismatch for " + oid + ": want " + want + ", got " + got + " in " + g.fees.length + " line(s) — fixed");
        });
        if (!Object.keys(updates).length) return;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates })
        }).then(function () { window.location.reload(); });
      })
      .catch(function () {});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sweepOrphans);
  else sweepOrphans();
  function bind() {}               // no-op kept for back-compat (delegation needs no rebind)
  window.IfsheCartFee = { bind: bind };
})();
